/**
 * @file Admin service — API calls for the admin panel.
 * @module services/admin
 */
import api from "./api";

export const adminService = {
  // Stats
  getStats: () => api.get("/admin/stats"),
  getEnhancedStats: () => api.get("/admin/stats/enhanced"),

  // Users
  getUsers: (params) => api.get("/admin/users", { params }),
  getUserDetail: (id) => api.get(`/admin/users/${id}`),
  updateRole: (id, role) => api.patch(`/admin/users/${id}/role`, { role }),
  toggleActive: (id) => api.patch(`/admin/users/${id}/toggle-active`),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  impersonateUser: (id) => api.post(`/admin/users/${id}/impersonate`),

  // Appointments (cross-professional)
  getAppointments: (params) => api.get("/admin/appointments", { params }),

  // Professionals
  getProfessionals: (params) => api.get("/admin/professionals", { params }),

  // Audit log
  getAuditLog: (params) => api.get("/admin/audit-log", { params }),

  // Notification log
  getNotifications: (params) => api.get("/admin/notifications", { params }),
  retryNotification: (id) => api.post(`/admin/notifications/${id}/retry`),

  // Settings
  getSettings: () => api.get("/admin/settings"),
  updateSetting: (key, value) => api.patch(`/admin/settings/${key}`, { value }),

  // Referrals
  getReferrals: () => api.get("/admin/referrals"),
};
